// Verde vocabulary expansion — FOOD theme (net-new cards).
//
// Extends the `food` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `spanish`, so every value is unique.
//   [ spanish, english, emoji, part_of_speech, gender, example_es, example_en ]

export const VOCAB_FOOD = [
  {
    theme: "food", tier: "A1", rows: [
      ["la manzana", "apple", "🍎", "noun", "f", "Como una manzana cada día.", "I eat an apple every day."],
      ["el tomate", "tomato", "🍅", "noun", "m", "El tomate está maduro.", "The tomato is ripe."],
      ["el pollo", "chicken", "🍗", "noun", "m", "Cenamos pollo con arroz.", "We're having chicken with rice for dinner."],
      ["el arroz", "rice", "🍚", "noun", "m", "El arroz está listo.", "The rice is ready."],
      ["la sopa", "soup", "🍲", "noun", "f", "La sopa está muy caliente.", "The soup is very hot."],
      ["el zumo", "juice", "🧃", "noun", "m", "Quiero un zumo de naranja.", "I want an orange juice."],
      ["la mantequilla", "butter", "🧈", "noun", "f", "Pon mantequilla en el pan.", "Put butter on the bread."],
      ["la naranja", "orange", "🍊", "noun", "f", "La naranja es dulce.", "The orange is sweet."],
      ["la patata", "potato", "🥔", "noun", "f", "Las patatas están fritas.", "The potatoes are fried."],
      ["el plátano", "banana", "🍌", "noun", "m", "El plátano todavía está verde.", "The banana is still green."],
    ],
  },
  {
    theme: "food", tier: "A2", rows: [
      ["la harina", "flour", "🌾", "noun", "f", "Necesito harina para el bizcocho.", "I need flour for the sponge cake."],
      ["la cucharadita", "teaspoon", "🥄", "noun", "f", "Añade una cucharadita de sal.", "Add a teaspoon of salt."],
      ["el cuenco", "bowl", "🥣", "noun", "m", "Bate los huevos en un cuenco.", "Beat the eggs in a bowl."],
      ["la sartén", "frying pan", "🍳", "noun", "f", "La sartén está muy caliente.", "The frying pan is very hot."],
      ["la olla", "pot", "🍲", "noun", "f", "Pon la pasta en la olla.", "Put the pasta in the pot."],
      ["asar", "to roast", "🔥", "verb", "", "Vamos a asar verduras al horno.", "We're going to roast vegetables in the oven."],
      ["picar", "to chop", "🔪", "verb", "", "Pica la cebolla muy fina.", "Chop the onion very finely."],
      ["la rodaja", "slice (round)", "🍋", "noun", "f", "Corta el limón en rodajas.", "Cut the lemon into slices."],
      ["crudo", "raw", "🥩", "adjective", "", "El pollo todavía está crudo.", "The chicken is still raw."],
      ["maduro", "ripe", "🥑", "adjective", "", "El aguacate ya está maduro.", "The avocado is ripe now."],
    ],
  },
  {
    theme: "food", tier: "B1", rows: [
      ["la sobremesa", "after-meal table talk", "☕", "noun", "f", "La sobremesa duró dos horas.", "The after-lunch chat lasted two hours."],
      ["el aperitivo", "appetizer / pre-meal drink", "🫒", "noun", "m", "Tomamos un aperitivo antes de comer.", "We had an appetizer before lunch."],
      ["la guarnición", "side dish", "🥗", "noun", "f", "El plato lleva una guarnición de verduras.", "The dish comes with a vegetable side."],
      ["aliñar", "to dress / season", "🫗", "verb", "", "Aliña la ensalada con aceite y vinagre.", "Dress the salad with oil and vinegar."],
      ["empalagoso", "sickly sweet", "🍯", "adjective", "", "Este postre es demasiado empalagoso.", "This dessert is too sickly sweet."],
      ["el comensal", "dinner guest / diner", "🍽️", "noun", "m", "Éramos ocho comensales en la mesa.", "There were eight of us at the table."],
      ["escurrir", "to drain", "💧", "verb", "", "Escurre la pasta antes de servirla.", "Drain the pasta before serving it."],
      ["a fuego lento", "on a low heat", "🔥", "phrase", "", "Cocina la salsa a fuego lento.", "Cook the sauce on a low heat."],
      ["el régimen", "diet", "🥦", "noun", "m", "Está a régimen desde enero.", "He's been on a diet since January."],
      ["el fogón", "stove / burner", "🍳", "noun", "m", "Tengo cuatro fogones en la cocina.", "I have four burners in the kitchen."],
    ],
  },
];
